import React from 'react'
import { TextField, InputAdornment } from '@material-ui/core'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { useController } from 'react-hook-form'

export default function TithingPercentage({ control, ...passThroughProps }) {
  const defaultValue = useCurrentUserProp('tithingPercentage')

  const { field, fieldState: { error, invalid } } = useController({
    name: 'tithingPercentage',
    defaultValue,
    control,
    rules: {
      pattern: { value: /^[1-9][0-9]?$|^99$/, message: 'Must be between 1 and 99' },
      required: { value: true, message: 'Required' },
    }
  })

  return (
    <TextField
      {...field}
      control={control}
      required
      label='Tithing Percentage'
      type='number'
      InputProps={{ endAdornment: <InputAdornment position='start'>%</InputAdornment> }}
      helperText={error?.message || '*Required'}
      error={invalid}
      { ...passThroughProps }
    />
  )
}